import React from 'react';
import * as S from './styled';
export const Audio = () => /*#__PURE__*/React.createElement(S.Icon, {
  xmlns: "http://www.w3.org/2000/svg",
  "aria-label": "Audio",
  viewBox: "0 -3 20 25"
}, /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "audio2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Mask",
  fillRule: "nonzero",
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9,0.757359313 L9,17.7279221 L4.271,12.9993593 L0,13 L0,5 L4.758,4.99935931 L9,0.757359313 Z M17,3 L17,15 L15,15 L15,3 L17,3 Z M13,6 L13,12 L11,12 L11,6 L13,6 Z",
  id: "path-1"
})))));